<template>
  <div id="aiFace" ref="aiFace">

    <div class="camera_outer">
    
      <div class="camera-box">

      <div class="people-outline">
             <svg width="100%" height="100%" viewBox="0 0 300 400" preserveAspectRatio="xMidYMid meet" ref="peopleOutlineImg">
            <defs>
              <mask id="face-mask">
                <rect width="100%" height="100%" fill="white" />
                <path d="M 150 40 C 110 40, 70 72, 50 136 C 30 200, 60 296, 90 336 C 110 356, 130 360, 150 360 C 170 360, 190 356, 210 336 C 240 296, 270 200, 250 136 C 230 72, 190 40, 150 40 Z" fill="black" />
              </mask>
            </defs>
            <rect width="100%" height="100%" fill="rgba(0, 0, 0, 0.8)" mask="url(#face-mask)" />
            <path d="M 150 40 C 110 40, 70 72, 50 136 C 30 200, 60 296, 90 336 C 110 356, 130 360, 150 360 C 170 360, 190 356, 210 336 C 240 296, 270 200, 250 136 C 230 72, 190 40, 150 40 Z" fill="none" stroke="#2dcc00" stroke-width="2" stroke-dasharray="6,4" opacity="1" />
          </svg>
      </div>
      <div class="video">
        <video ref="videoCamera"
        style="margin: 0 auto;"
        :class="['videoCamera', { rotateY180: isMirror }]"
         webkit-playsinline="true" playsinline="true" preload="metadata" x-webkit-airplay="deny"
          x5-video-player-type="h5" :width="videoWidth" :height="videoHeight"  autoplay></video>
      </div>
      <img v-if="HkBaseFace" :src="HkBaseFace" class="captured-preview" alt="拍摄照片" />
      <canvas :class="['canvas', { rotateY180: isMirror }]" style="display: none" ref="canvasCamera" :width="videoWidth" :height="videoHeight">
      </canvas>
      </div>
      
         <div class="test_text" v-if="HkBaseFace!==''">
            
     <div style="width: 20%;">
              <div  v-if="isCheck"><img width="100%" :src="require('@/assets/image/检测通过.png')" alt=""></div>
              <div v-else><img width="100%" :src="require('@/assets/image/检测不通过.png')" alt=""></div>
          </div>
          <div>
               <div v-for="(item,i) in faceCodeEntityList"  :style="{ color: colorList[item.status]}" :key="i" class="testTextLi">
            <van-icon name="checked" v-if="+item.status==1"/>
            <van-icon name="clear" v-else/>
            &nbsp;
            {{item.msg}} 
            <span v-if="item.msg == '照片质量检测'">
              {{ item.value }}
              <template v-if="item.value&&+item.value >= 0.72">
                (>= 0.72)通过
              </template>
              <template v-else>
                (< 0.72)未通过
              </template>
            </span>
              <span v-if=" item.msg=='人像占比检测'">
                {{ item.value }}
               <template v-if="item.value&&item.value >= 0.2">
                (>= 0.2)通过
              </template>
              <template v-else>
                (<0.2)未通过
              </template>
            </span>
          </div>
          </div>
          </div>


    
     </div> 
<van-popup v-model:show="showUserDialog" style="height:100vh;width:100%;" width="100%"  title="" :show-confirm-button='false' >
  <div style="padding:6px;text-align: center;font-size: 4vw;">
  <div >
    <!-- <span>体测准考证：</span>
    <span v-if="!!teacherFaceStatus" style="color:green;"><van-icon name="passed" />已提交</span>
    <span v-else  style="color:red;"><van-icon name="close" />未提交</span> -->
  
    <van-image
      style="margin-top:10px;"
      width="85%"
      fit="cover"
      :src="require('@/assets/image/faceStandard.jpg')"
    />
  </div>

 </div> 
<van-button round  style="width:80%;margin:10px 10%;height:40px;"  color="linear-gradient(to right, #ff6034, #ee0a24)" @click="onStepShow">
  <span >去拍照</span>
</van-button>

</van-popup>


      <div class="btnBox">
         <div v-if="isCheck"> 
          <van-button round type="info" style="width:200px;"  @click="submitBase64Img">生成准考证</van-button>
         </div>

        <div v-else style="display: flex;text-align: center;margin-top: 10px;" class="btnBox" >

        <div style="width:30%;height:40px;">
          <img  width="38" :src="require('@/assets/icon/问号.png')" alt="" @click="showUserDialog = true">
        </div>

        <div style="width:40%;">
          <!-- success -->
          <div class="setImageDiv" @click="setImage" v-if="HkBaseFace==''">
           <img width="100%" :src="require('@/assets/image/拍照按钮.png')" alt="" >
          </div>
          <van-button @click="reAction" color="linear-gradient(to right, #ff6034, #ee0a24)" style="width:100%;font-size:16px;" round type="info"  v-else>
          &nbsp;重新拍照
          </van-button>
        </div>

        <div style="width:30%;height:40px;">
        <img width="40" :src="require('@/assets/icon/切换镜头.png')" alt="" @click="changeFacingMode">
        </div>
        </div>

      </div>
    
    </div>

  </div>
</template>

<script>

import { Toast } from 'vant'
import { checkFace } from '@/api/admissionTicket'
// import { updateFitnessActivityList, selectWeightscore, getTermInfoList } from '../../services/fitnessAchievement'
import store from '@/store'
import { insertIntoFaceData} from "@/api/admissionTicket.js";

export default {
  name: 'camera',
  components: {  },
  data () {
    return {
      stepShow:1,
      showUserDialog:true,
      videoWidth: 300,
      videoHeight: 400, // 修改为 400
      imgSrc: '',
      HkBaseFace: '',
      HrBaseFace: '',
      thisCancas: null,
      thisContext: null,
      thisVideo: null,
      openVideo: false,
      show: false,
      userInfo: {},
      percent: 0,
      faceCheckFlag: true,
      appeal: 0,
      appealShow: false,
      remindShow: false,
      appealContent: '',
      phoneNumber: '',
      termCode: '',
      facingMode:'environment',
      isCheck:false,
      studentInfo:{},
      isMirror:false,
      faceCodeEntityList:{},
      colorList:['#d82121','#2dcc00'],
      showUserDialog:true,
      dataList:[]
    }
  },
  async created () {
    if (this.$route.query.studentInfo) {
      try {
        this.studentInfo = JSON.parse(this.$route.query.studentInfo)
      } catch (e) {
        console.error('解析studentInfo失败:', e)
      }
    }
  },

  mounted () {
    this.getCompetence()
  },
  methods: {
    // 提示
    onStepShow(){
        this.showUserDialog = false
    },
    changeFacingMode(){
      if (this.facingMode == 'environment') {
        this.facingMode = 'user'
      }else if (this.facingMode == 'user') {
        this.facingMode = 'environment'
      }
      this.isMirror = !this.isMirror
      this.getCompetence()
    },

    gotDevices(mediaDevices) {
      let _this =this
      this.dataList =[]
      let count = 1;
      mediaDevices.forEach(mediaDevice => {
        if (mediaDevice.kind === "videoinput") {
          mediaDevice.count = `${count++}`
          _this.dataList.push(mediaDevice)
        }
      });
    },
    reAction () {
      this.HkBaseFace = ''
      this.HrBaseFace = ''
      this.isCheck = false
      this.faceCodeEntityList = []
      if (this.thisVideo && this.thisVideo.parentElement) {
        this.thisVideo.parentElement.style.display = 'block'
      }
      if (this.$refs.peopleOutlineImg) {
        this.$refs.peopleOutlineImg.style.opacity = 0.8
      }
    },
    close () {
      this.$router.back()
    },
    submitBase64Img () {
      const HkBaseFace = this.HkBaseFace.replace(/^data:image\/\w+;base64,/, '')
      this.studentInfo.faceData = HkBaseFace
      insertIntoFaceData(this.studentInfo).then(res=>{
          this.$notify({ type: "success", message: '生成成功！' });
          this.$router.back(-1)
      })
    },

    check () {
      const HkBaseFace = this.HkBaseFace.replace(/^data:image\/\w+;base64,/, '')
      checkFace({
        faceData:HkBaseFace,
      }).then(res=> { 
        console.log(res);
        this.faceCodeEntityList = res.data.faceCodeEntityList
        this.isCheck = true
        res.data?.faceCodeEntityList.forEach(el=>{
          if (+el.status==0) {
            this.isCheck = false
          }
        })
      })
    },
    successFace () {
      this.$router.push({
        path: '/myFitness'
      })
    },
    
    // 调用权限（打开摄像头功能）
     getCompetence (deviceId) {
      this.thisCancas = this.$refs.canvasCamera
      this.thisContext = this.thisCancas.getContext('2d')
      this.thisVideo = this.$refs.videoCamera
      this.thisVideo.style.display = 'block'
      
      if (navigator.mediaDevices === undefined) {
        navigator.mediaDevices = {}
      }
      if (navigator.mediaDevices.getUserMedia === undefined) {
        navigator.mediaDevices.getUserMedia = (constraints) => {
          const getUserMedia =
            navigator.webkitGetUserMedia ||
            navigator.mozGetUserMedia ||
            navigator.getUserMedia
          if (!getUserMedia) {
            return Promise.reject(
              new Error('getUserMedia is not implemented in this browser')
            )
          }
          return new Promise((resolve, reject) => {
            getUserMedia.call(navigator, constraints, resolve, reject)
          })
        }
      }
      if (window.stream) {
        window.stream.getTracks().forEach(track => {
          track.stop()
        })
      }
      const constraints = {
        audio: false,
        video: {
          sourceId: 'default',
          facingMode:  { exact: this.facingMode },
          // 请求高分辨率源，避免裁剪后模糊
          width: { ideal: 1920 },
          height: { ideal: 1080 }
        }
      }
       navigator.mediaDevices
        .getUserMedia(constraints)
        .then((stream) => {
          this.thisVideo.srcObject = stream
          window.stream = stream
          this.thisVideo.play()
          this.thisVideo.onloadedmetadata = (e) => {
            this.thisVideo.play()
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },

    // 绘制图片（拍照功能）- 改为无压缩且防拉伸裁切算法
    setImage () {
      const vw = this.thisVideo.videoWidth; // 视频流的真实物理宽度
      const vh = this.thisVideo.videoHeight; // 视频流的真实物理高度
      const cw = this.videoWidth;   // 画布需要的宽度 (300)
      const ch = this.videoHeight;  // 画布需要的高度 (400)

      // 计算模拟 object-fit: cover 的裁剪范围，防止画面发生胖瘦拉伸
      const videoRatio = vw / vh;
      const canvasRatio = cw / ch;
      let sx, sy, sWidth, sHeight;

      if (videoRatio > canvasRatio) {
        // 视频过宽：截取中间部分
        sHeight = vh;
        sWidth = sHeight * canvasRatio;
        sx = (vw - sWidth) / 2;
        sy = 0;
      } else {
        // 视频过高：截取中间部分
        sWidth = vw;
        sHeight = sWidth / canvasRatio;
        sx = 0;
        sy = (vh - sHeight) / 2;
      }

      // 镜像处理
      if (this.isMirror) {
        this.thisContext.translate(cw, 0)
        this.thisContext.scale(-1, 1)
      }

      // 使用 9 参数方法进行精确裁切绘制
      this.thisContext.drawImage(this.thisVideo, sx, sy, sWidth, sHeight, 0, 0, cw, ch)

      if (this.isMirror) {
        this.thisContext.setTransform(1, 0, 0, 1, 0, 0) // 恢复状态
      }

      // 直接获取最高质量的原图base64链接，去除压缩逻辑
      const base64 = this.thisCancas.toDataURL('image/jpeg', 1)
      
      this.HkBaseFace = base64
      this.HrBaseFace = base64
      
      if (this.thisVideo && this.thisVideo.parentElement) {
        this.thisVideo.parentElement.style.display = 'none'
      }
      if (this.$refs.peopleOutlineImg) {
        this.$refs.peopleOutlineImg.style.opacity = 0.8
      }
      
      // 校验照片
      this.check()
    },

    // 关闭摄像头
    stopNavigator () {
      if(this.thisVideo && this.thisVideo.srcObject){
        this.thisVideo.srcObject.getTracks()[0].stop()
      }
    },

    // 其他原有辅助方法保留
    dataURLtoFile (dataurl, filename) {
      const arr = dataurl.split(',')
      const mime = arr[0].match(/:(.*?);/)[1]
      const bstr = atob(arr[1])
      let n = bstr.length
      const u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], filename, { type: mime })
    },
    onOversize () {
      Toast.fail('图片大小不能超过 30kb')
    },
    afterRead (file) {
      this.thisContext.drawImage(this.thisVideo, 0, 0, 300, 400)
      this.imgSrc = file.content
      this.thisCancas.style.display = 'block'
      this.thisVideo.parentElement.style.display = 'none'
    },
    getSchoolTerm () {
      return new Promise((resolve) => {
        getTermInfoList().then(({ data }) => {
          this.list = data.map((item) => {
            return {
              text: item.name,
              value: item.code
            }
          })
          this.semesterInfo = data.filter((item) => item.isActive === '1')[0]
          this.termCode = this.semesterInfo.code
          resolve()
        })
      })
    },
    onDropChange (termCode) {
      selectWeightscore({
        fitnessAchievementActivity: {
          snCode: this.userInfo.snCode,
          termCode
        },
        type: 3
      }).then((data) => {
        this.appeal = data?.body?.status
      })
    },
    changeRemindShow () {
      if (+(this.appeal) === 0) {
        this.remindShow = true
      }
    },
    changeShow () {
      this.remindShow = false
      this.appealShow = true
      this.phoneNumber = ''
      this.appealContent = ''
    },
    forAppeal () {
      if (this.appealContent.length > 10) {
        updateFitnessActivityList({
          phoneNumber: this.phoneNumber,
          type: 3,
          fitnessAchievementActivity: {
            appealContent: this.appealContent,
            snCode: this.userInfo.snCode
          }
        }).then(({ status }) => {
          if (status === '00') {
            this.appealShow = false
            this.$router.go(-1)
          }
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
#aiFace {
  background: #fff;
  height: 100vh;
  background-color: #000;

  .title {
    font-size: 24px;
    color: #333333;
    font-weight: 700;
    text-align: center;
    padding: 40px 0;
  }
  .camera-box{
    width: 300px;
    height: 400px; /* 统一改为 400px */
    position: relative;
    margin: 0 auto;
    overflow: hidden; /* 防止内容溢出 */
  }
  .video {
    width: 300px;
    height: 400px; /* 统一改为 400px */
    background-size: 100% 100%;
    margin: 0 auto;
    position: relative;
    display: flex;
    align-items: center;
    .videoCamera {
      margin: 0 auto;
      width: 100%;
      height: 100%;
      object-fit: cover; /* 保证视频画面填满但不拉伸 */
    }
  }

  .people-outline {
    height: 400px; /* 统一改为 400px */
    width: 300px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 2;
    background-repeat: no-repeat;
    background-size: contain;
  }
  .people-outline img{
    height: 100%;
    width: 100%;
    opacity: 0.8;
  }
  .canvas {
    margin: 0 auto;
    width: 300px;
    height: 400px; /* 统一改为 400px */
    background-size: 100% 100%;
  }
  .captured-preview {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: 1;
  }
  .test_text{
    display: flex;
    text-align: center;
    font-size: 4vw;
    margin-top: 30px;
    letter-spacing:1.2px;
    .testTextLi{
      line-height: 36px;
    }
  }
 .green{
      width: 100%;
    }
    .btnBox{
    display: flex;
    justify-content: center;
    align-items: center;
    align-content: center;
    width: 100%;
    margin-top: 50px;
    .setImageDiv{
      width: 80px;
      height: 80px;
      text-align: center;
      margin: 0 auto;
    }
  }
  .action {
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
    margin-top: 40px;

    .uploader-btn {
      margin-top: 10px;
      padding-bottom: 3px;
      font-size: 12px;
      border-bottom: 1px solid #333333;
    }
  }

  .resetContent {
    width: 280px;
    min-height: 320px;
    border-radius: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    .percent {
      margin-top: 50px;
      font-size: 50px;
      font-weight: 700;
      color: #506df5;
    }

    .text {
      font-size: 16px;
      line-height: 28px;
      color: #1b4a6e;
      margin: 20px 0;
    }

    .reset {
      width: 60%;
      height: 50px;
      line-height: 50px;
      text-align: center;
      color: #fff;
      font-size: 16px;
      font-weight: 600;
      background-color: #42caa5;
      border-radius: 30px;
      margin-top: 25px;
    }
  }

  .camera_outer {
    padding: 20px 0;

    .tips {
      text-align: center;
      padding: 0 20px 20px;
      width: 70%;
      margin: 0 auto;
    }
  }

  .img_bg_camera {
    padding: 20px 0;
    text-align: center;

    p {
      font-size: 14px;
      color: #333333;
      text-align: center;
    }
  }

  .tx_img {
    border-radius: 50%;
    width: 300px;
    height: 400px; /* 同步修改为 400px */
  }

  .button-all {
    display: flex;
    justify-content: space-around;
    margin-top: 20px;
    position: fixed;
    bottom: 10%;
    width: 100%;
    z-index: 6;
  }
  .button-appeal{
    float: right;
    margin-right: 18vw;
    position: fixed;
    bottom: 5%;
    right: 0;
  }
  /deep/ .van-button--info,
  .van-button--default {
    width: 124px;
  }
  .text_r{
    text-align: right;
  }
 .center_text{
            text-align: left;
            font-size: 13px;
            margin-bottom: 50px;
            padding: 0 15px;
            .center_title{
              color: #b9b8b8;
            }
            .center_value{
              font-size: 14px;
              font-weight: 500;

            }
        }
}
</style>